import React, { useState, useEffect } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import CloseIcon from '../Icons/Close';
import Styled from './styled';
import type { IStateController } from '../../../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../../../lib/widget/state/state.types';

interface AlertProps extends WithTranslation {
  sideBarPosition?: string;
}

const Alert: React.FC<AlertProps> = ({ t, i18n, sideBarPosition }) => {
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);
  const { Widget } = window;
  const [state, setState] = useState({ visible: false, hintHidden: false, pushkinHidden: false });
  const { meta } = Widget.metaController;

  const showAlerts = () => {
    setState((prevState) => ({
      ...prevState,
      visible: true,
    }));
  };

  useEffect(() => {
    stateController.addOnceListener(stateController.events.DATA_LOADED, showAlerts);
  }, []);

  const hideHint = () => {
    setState((prevState) => ({
      ...prevState,
      hintHidden: true,
    }));
  };

  const hidePushkin = () => {
    setState((prevState) => ({
      ...prevState,
      pushkinHidden: true,
    }));
  };

  if (!state.visible) return null;

  const alertAvailable = i18n.language === 'ru' || !i18n.language;

  // const stopPropagation = useCallback((e) => e.stopPropagation(), []);
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <Styled.Container sideBarPosition={sideBarPosition}>
      {!state.hintHidden && meta.hintText && (
        <Styled.Item onMouseMove={stopPropagation}>
          <div>
            <Styled.Attention>{t('alerts.attention')}</Styled.Attention>
            {meta.hintText}
            <Styled.Close onClick={hideHint}>
              <CloseIcon />
            </Styled.Close>
          </div>
        </Styled.Item>
      )}
      {!state.pushkinHidden && meta.is_pushkin && alertAvailable && (
        <Styled.Item onMouseMove={stopPropagation}>
          <Styled.PushkinIcon />
          <div>
            <Styled.Attention>{t('alerts.pushkin_1')}</Styled.Attention>
            {t('alerts.pushkin_2')}
            <Styled.Close onClick={hidePushkin}>
              <CloseIcon />
            </Styled.Close>
          </div>
        </Styled.Item>
      )}
    </Styled.Container>
  );
};

export default withTranslation()(Alert);
